import { loadLanguageAsync } from '@/i18n'

export default {
  created () {
    loadLanguageAsync()
  },
  computed: {
    goSupportPage () {
      return 'https://support.exosite.com/hc/en-us/requests/new'
    }
  },
  name: 'NotFound'
}



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js